<template>
    <main>
        <section class="carousel-wrapper-new">
            <div class="main-img">
                <picture class="main-img-bg">
                    <source srcset="/activation2.avif" type="image/avif" />
                    <img src="/activation2.svg" alt="hero image" />
                </picture>
                <div class="container1366 section1-container">
                    <div class="section1-left">
                        <h1 class="section1-title">{{ $t("lp-collection21") }}</h1>
                        <h2 class="section1-subtitle">{{ $t("lp-collection20") }}</h2>
                    </div>
                    <div class="section1-right">
                        <div class="home-section1-img">
                            <nuxt-img alt="phone image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/main_home_phone_it.png" />
                            <nuxt-img alt="phone image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/main_home_phone_fr.png" />
                            <nuxt-img alt="phone image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/main_home_phone_de.png" />
                            <nuxt-img alt="phone image" v-else-if="$i18n.locale === 'ru'" format="webp" provider="static" fit="cover" src="/main_home_phone_ru.png" />
                            <nuxt-img alt="phone image" v-else format="webp" provider="static" fit="cover" src="/main_home_phone.png" />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="reg-wraper">
            <div class="reg-inner">
                <!-- new one 4547708611999159 /  old one 1109186269876785-->
                <v-facebook-login v-if="!nextStep && isBrowser" class="fb-reg" app-id="4547708611999159" @login="loginFb" @sdk-init="handleSdkInit" :login-options=scopeOptions>
                    <button slot="login">{{ $t('reg-fb')}}</button>
                </v-facebook-login>
                <div class="social-or" v-if="!nextStep">{{ $t('lp-pp4') }}</div>

                <div class="login-inner-container" v-if="!nextStep">
                    <div class="reg-col">
                        <v-flex v-if="isBrowser">
                            <span class="login-label">{{ $t('myprofile1') }} *</span>
                            <v-text-field
                                id="regFName"
                                ref="regFName"
                                v-model="regFName"
                                class="email-input"
                                :rules="[rules.required]"
                                :error="$v.regFName.$error"
                            ></v-text-field>
                        </v-flex>
                        <v-flex v-if="isBrowser">
                            <span class="login-label">{{ $t('myprofile2') }} *</span>
                            <v-text-field
                                v-model="regLName"
                                class="email-input"
                                :rules="[rules.required]"
                                :error="$v.regLName.$error"
                            ></v-text-field>
                        </v-flex>
                        <v-flex>
                            <span class="login-label">Email *</span>
                            <v-text-field
                                ref="email"
                                v-model="regEmail"
                                class="email-input"
                                :rules="[rules.required, rules.emailValid]"
                            ></v-text-field>
                        </v-flex>
                    </div>
                    <div class="reg-col">
                        <v-flex>
                            <span class="login-label">Password *</span>
                            <v-text-field
                                ref="regPassword"
                                v-model="regPassword"
                                :append-icon="secureRegPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="secureRegPassword ? 'password' : 'text'"
                                name="input-10-1"
                                hint="At least 8 characters"
                                @click:append="secureRegPassword = !secureRegPassword"
                                v-on:keyup.enter="registration"
                            >
                            </v-text-field>
                        </v-flex>
                        <v-checkbox
                            v-model="checked18"
                            class="check-terms"
                            :label="$t('register-confirm18')"
                        ></v-checkbox>
                        <v-checkbox
                            v-model="checkedTerms"
                            class="check-terms"
                        >
                            <div slot="label">
                                {{ $t('register-terms') }}
                            </div>
                        </v-checkbox>
                        <v-checkbox
                            v-model="checkedNews"
                            :label="$t('register-news')"
                            class="check-terms"
                        ></v-checkbox>
                        <v-flex>
                            <div class="errors-container2" v-if="errorMsg !== ''">
                                <p>{{ errorMsg }}</p>
                            </div>
                        </v-flex>
                        <v-flex>
                            <v-btn class="submit login-submit" v-on:click="registration">{{
                                    $t('register-create')
                                }}
                            </v-btn>
                        </v-flex>
                    </div>
                </div>
                <div class="login-inner-container" v-else>
                    <div class="login-success">
                        <h2>Success!</h2>
                        <div class="additional-info">
                            Check your email for an account activation link!
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="home-section7">
            <h2>{{ $t("new-home37") }}</h2>
            <div class="title-border"></div>
            <div class="container1366 padding200">
                <div class="journey-item journey-item1">
                    <div class="journey-num-border">
                        <div class="journey-num">1</div>
                    </div>
                    <div class="journey-title">{{ $t("new-home38") }}</div>
                </div>
                <div class="journey-separator journey-separator1"></div>
                <div class="journey-item journey-item2">
                    <div class="journey-num-border">
                        <div class="journey-num">2</div>
                    </div>
                    <div class="journey-title">{{ $t("new-home39") }}</div>
                </div>
                <div class="journey-separator journey-separator2"></div>
                <div class="journey-item journey-item3">
                    <div class="journey-num-border">
                        <div class="journey-num">3</div>
                    </div>
                    <div class="journey-title">{{ $t("new-home40") }}</div>
                </div>
                <div class="journey-separator journey-separator3"></div>
                <div class="journey-item journey-item4">
                    <div class="journey-num-border">
                        <div class="journey-num">4</div>
                    </div>
                    <div class="journey-title">{{ $t("new-home41") }}</div>
                </div>

                <div class="home-section2-btn-wrapper center">
                    <nuxt-link :to="localePath('/register')" class="home-section2-btn1 v-btn__content ga4-reg-btn">{{ $t("new-home42") }}</nuxt-link>
                    <nuxt-link :to="localePath('/how-it-works')" class="home-section2-btn2">{{ $t("new-home4") }}</nuxt-link>
                </div>
            </div>
        </section>
        <section id="how-to-buy" class="section-how-to-buy">
            <h2>How it works</h2>
            <div class="title-border"></div>
            <div class="container1366 padding200">
                <div class="section-subtitle">{{ $t("howitworks4") }}</div>
                <div class="how-buy-collection-wrapper" v-if="mobileCheck">
                    <div class="home-left-50">
                        <nuxt-link :to="localePath('/collections')">
                            <div class="section-how-to-buy-img"></div>
                        </nuxt-link>
                    </div>
                    <div class="home-right-50">
                        <i18n path="howitworks5" tag="h3">
                            <nuxt-link :to="localePath('/collections')" place="tobereplaced">{{ $t('home-title2') }}</nuxt-link>
                        </i18n>
                        <i18n path="howitworks6" tag="div" class="content-text">
                            <nuxt-link :to="localePath('/collections')" place="tobereplaced">{{ $t('home-title2') }}</nuxt-link>
                        </i18n>
                        <nuxt-link :to="localePath('/collections')" class="blue-btn how-to-btn">{{ $t("howitworks7") }}</nuxt-link>
                    </div>
                </div>
                <div class="how-buy-collection-wrapper" v-else>
                    <div class="home-left-50">
                        <i18n path="howitworks5" tag="h3">
                            <nuxt-link :to="localePath('/collections')" place="tobereplaced">{{ $t('home-title2') }}</nuxt-link>
                        </i18n>
                        <i18n path="howitworks6" tag="div" class="content-text">
                            <nuxt-link :to="localePath('/collections')" place="tobereplaced">{{ $t('home-title2') }}</nuxt-link>
                        </i18n>
                        <nuxt-link :to="localePath('/collections')" class="blue-btn how-to-btn">{{ $t("howitworks7") }}</nuxt-link>
                    </div>
                    <div class="home-right-50">
                        <nuxt-link :to="localePath('/collections')">
                            <div class="section-how-to-buy-img"></div>
                        </nuxt-link>
                    </div>
                </div>
                <div :class="$i18n.locale.toLowerCase() === 'de' ? 'how-buy-live-market-wrapper-de' : 'how-buy-live-market-wrapper'">
                    <div class="home-left-50">
                        <nuxt-link :to="localePath('/trading-desk')">
                            <div class="section-how-to-buy-img2"></div>
                        </nuxt-link>
                    </div>
                    <div class="home-right-50">
                        <h3><nuxt-link :to="localePath('/trading-desk')">{{ $t("home-title3") }}</nuxt-link></h3>
                        <i18n path="howitworks8" tag="div" class="content-text">
                            <nuxt-link :to="localePath('/trading-desk')" place="tobereplaced">{{ $t('home-title3') }}</nuxt-link>
                        </i18n>
                        <nuxt-link :to="localePath('/trading-desk')" class="blue-btn how-to-btn">Start investing</nuxt-link>
                    </div>
                </div>
                <div class="how-buy-enprimeur-wrapper" v-if="mobileCheck">
                    <div class="home-left-50">
                        <nuxt-link :to="localePath('/en-primeur')">
                            <div class="section-how-to-buy-img3"></div>
                        </nuxt-link>
                    </div>
                    <div class="home-right-50">
                        <h3><nuxt-link :to="localePath('/en-primeur')">En Primeur</nuxt-link></h3>
                        <i18n path="howitworks10" tag="div" class="content-text">
                            <nuxt-link :to="localePath('/en-primeur')" place="tobereplaced">{{ $t('home-title4') }}</nuxt-link>
                        </i18n>
                        <nuxt-link :to="localePath('/en-primeur')" class="blue-btn how-to-btn">Learn more</nuxt-link>
                    </div>
                </div>
                <div class="how-buy-enprimeur-wrapper" v-else>
                    <div class="home-left-50">
                        <h3><nuxt-link :to="localePath('/en-primeur')">En Primeur</nuxt-link></h3>
                        <i18n path="howitworks10" tag="div" class="content-text">
                            <nuxt-link :to="localePath('/en-primeur')" place="tobereplaced">{{ $t('home-title4') }}</nuxt-link>
                        </i18n>
                        <nuxt-link :to="localePath('/en-primeur')" class="blue-btn how-to-btn">En Primeur</nuxt-link>
                    </div>
                    <div class="home-right-50">
                        <nuxt-link :to="localePath('/en-primeur')">
                            <div class="section-how-to-buy-img3"></div>
                        </nuxt-link>
                    </div>
                </div>
            </div>
        </section>
        <section id="our-service" class="section-take-care">
            <div class="container1366 padding200 padding80">
                <h2>{{ $t("howitworks31") }}</h2>
                <div class="title-border"></div>
                <div class="we-take-care-wrapper">
                    <div class="we-take-care-col">
                        <h3 class="we-take-care-title">
                            <nuxt-link :to="localePath('/support')">{{ $t("howitworks32") }}</nuxt-link>
                        </h3>
                        <i18n path="howitworks33" tag="div" class="we-take-care-text">
                            <nuxt-link :to="localePath('/support')" place="tobereplaced">{{ $t('howitworks14') }}</nuxt-link>
                        </i18n>
                    </div>
                    <div class="we-take-care-col we-take-care-col2">
                        <h3 class="we-take-care-title">
                            <nuxt-link :to="localePath('/support')">{{ $t("howitworks34") }}</nuxt-link>
                        </h3>
                        <i18n path="howitworks35" tag="div" class="we-take-care-text">
                            <nuxt-link :to="localePath('/support')" place="tobereplaced">{{ $t('howitworks36') }}</nuxt-link>
                        </i18n>
                    </div>
                    <div class="we-take-care-col we-take-care-col3">
                        <h3 class="we-take-care-title">
                            <nuxt-link :to="localePath('/support')">{{ $t('howitworks37') }}</nuxt-link>
                        </h3>
                        <i18n path="howitworks38" tag="div" class="we-take-care-text">
                            <nuxt-link :to="localePath('/trading-desk')" place="tobereplaced">{{ $t('home-title3') }}</nuxt-link>
                        </i18n>
                    </div>
                </div>
            </div>
        </section>
        <section id="safe-hands" class="section-safe-hands">
            <div class="container1366 padding200 padding80">
                <h2>{{ $t('howitworks39') }}</h2>
                <div class="title-border"></div>
                <div class="how-safe-hands-wrapper">
                    <div class="home-left-50">
                        <div class="safe-hands-col1">
                            <h3 class="we-take-care-title">
                                <nuxt-link :to="localePath('/support')">{{ $t('howitworks40') }}</nuxt-link>
                            </h3>
                            <i18n path="howitworks41" tag="div" class="we-take-care-text">
                                <nuxt-link :to="localePath('/support')" place="tobereplaced">{{ $t('howitworks42') }}</nuxt-link>
                            </i18n>
                        </div>
                    </div>
                    <div class="home-right-50">
                        <div class="safe-hands-col2">
                            <h3 class="we-take-care-title">
                                <nuxt-link :to="localePath('/support')">{{ $t('howitworks43') }}</nuxt-link>
                            </h3>
                            <div class="we-take-care-text">{{ $t('howitworks44') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="lp-register">
            <div class="container1366 padding200 padding80">
                <div class="marginBottom16">Register now and get free storage and insurance when you purchase your first Collection</div>
                <nuxt-link :to="localePath('/register')" class="home-section1-btn1 v-btn__content ga4-reg-btn">Register Now</nuxt-link>
            </div>
        </section>
    </main>
</template>

<script>
    import {required, email, minLength} from 'vuelidate/lib/validators';
    import {mapActions, mapGetters} from "vuex";
    import {GCommon} from "@/store/getters";
    import 'vueperslides/dist/vueperslides.css'
    import {AAuth} from "@/store/actions";
    import {MAuth} from "@/store/mutations";

    export default {
        name: 'home',
        validations: {
            regFName: {
                required
            },
            regLName: {
                required
            },
            regEmail: {
                required,
                email
            },
            regPassword: {
                required,
                minLength: minLength(8)
            }
        },
        head: {
            title: 'En Primeur Purchase | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'home page-lp-collections'
            }
        },
        components: {
            VFacebookLogin: () => process.client ? import('vue-facebook-login-component') : null
        },
        data() {
            return {
                isBrowser: false,
                scopeOptions: {scope: ['email', 'public_profile']},
                show: false,
                showContactUs: false,
                appStore: false,
                googlePlay: false,
                collectionItems: [],
                topCollectionItems: [],
                restCollectionsItems: [],
                topEnCollectionItems: [],
                moreCollectionsItems: [],
                popularWines: [],
                popularEnWines: [],
                selectedTab: 3,
                successMessage: false,
                successMessageEn: false,
                errorMsg: '',
                errorMsg2: '',
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                rules: {
                    required: value => !!value || 'Required.',
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.reg.test(value) || 'Invalid email'
                },
                regEmail: '',
                regPassword: '',
                regFName: '',
                regLName: '',
                countryId: 224,
                isLoading: false,
                checkedTerms: false,
                checked18: false,
                checkedNews: true,
                secureRegPassword: true,
                nextStep: false
            }
        },
        computed: {
            ...mapGetters({
                mobileCheck: GCommon.GET_MOBILE_VERSION
            })
        },
        methods: {
            goSection(val) {
                this.$nuxt.$emit("goToSection", val);
            },
            isEmailValid(email) {
                return this.reg.test(email)
            },
            goToLogin() {
                this.$router.push(this.localePath({path: '/login'}));
            },
            resendMail() {
                this.sendMail(this.regEmail)
            },
            registration() {
                this.$v.regFName.$touch();
                this.$v.regLName.$touch();
                if (this.regEmail && this.regPassword && !this.$v.regEmail.$invalid && !this.$v.regPassword.$invalid && !this.$v.regFName.$invalid && !this.$v.regLName.$invalid) {
                    if (this.checkedTerms && this.checked18) {
                        this.isLoading = true;
                        let payload = {
                            email: this.regEmail,
                            password: this.regPassword,
                            confirmPassword: this.regPassword,
                            firstname: this.regFName,
                            lastname: this.regLName,
                            countryId: this.countryId,
                            phoneNumber: '',
                            name: '',
                            enabledNotification: this.enabledNotification === true ? 1 : 0,
                            newsletter: this.checkedNews
                        };
                        this.signup(payload).then(res => {
                            if (res.reasonPhrase === "Created") {
                                this.nextStep = true;
                            }

                            this.$gtm.push({ event: "registration" });
                            window.fbq('track', 'CompleteRegistration');
                            window.uetq = window.uetq || [];
                            window.uetq.push("event", "signup", {});
                            this.$gtm.push({
                                'event': 'UETRegistration',
                                'ecomm_pagetype': 'conversion'
                            });
                        }).catch(err => {
                            this.isLoading = false;
                            if (err.data.errors) {
                                if (err.data.errors.Email.length) {
                                    err.data.errors.Email.forEach(err => {
                                        this.errorMsg = err;
                                    })
                                } else if (err.data.errors.GeneralError.length) {
                                    err.data.errors.GeneralError.forEach(err => {
                                        this.errorMsg = err;
                                    })
                                } else {
                                    this.errorMsg = 'Unexpected behavior. Please check your internet connection or try again later.';
                                }
                            }
                        })
                    } else {
                        this.errorMsg = 'You must agree with the terms of service and confirm that you are at least 18 years old.';
                    }
                } else {
                    this.errorMsg = 'Please fill the above information.';
                }

            },
            ...mapActions({
                signup: AAuth.REG_USER,
                sendMail: AAuth.SEND_MAIL
            }),
            handleSdkInit({FB, scope}) {
                this.FB = FB;
                this.fbScope = scope
            },
            loginFb(response) {
                if (typeof response !== 'undefined' && response.status === "connected") {
                    let _loginCtrl = this;

                    this.$store.dispatch(AAuth.LOGIN_EXTERNAL_USER, {accessToken: response.authResponse.accessToken}).then((res) => {
                        let token = res.access_token;
                        this.$nuxt.$emit('logged', 'User logged');
                        localStorage.setItem('access_token', token);
                        _loginCtrl.$store.commit(MAuth.SET_ACCESS_TOKEN, token);
                        _loginCtrl.$gtm.push({ event: "registration" });
                        window.fbq('track', 'CompleteRegistration');
                        window.uetq = window.uetq || [];
                        window.uetq.push("event", "signup", {});
                        _loginCtrl.$gtm.push({
                            'event': 'UETRegistration',
                            'ecomm_pagetype': 'conversion'
                        });
                        _loginCtrl.$router.push(this.localePath({path: '/home/collections'}));
                    });
                } else if (typeof response === 'undefined') {
                    let _loginCtrl = this;
                    let _token = this.FB.getAccessToken();

                    this.$store.dispatch(AAuth.LOGIN_EXTERNAL_USER, {accessToken: _token}).then((res) => {
                        let token = res.access_token;
                        localStorage.setItem('access_token', token);
                        _loginCtrl.$store.commit(MAuth.SET_ACCESS_TOKEN, token);
                        _loginCtrl.$gtm.push({ event: "registration" });
                        window.fbq('track', 'CompleteRegistration');
                        window.uetq = window.uetq || [];
                        window.uetq.push("event", "signup", {});
                        _loginCtrl.$gtm.push({
                            'event': 'UETRegistration',
                            'ecomm_pagetype': 'conversion'
                        });
                        _loginCtrl.$router.push(this.localePath({path: '/home/collections'}));
                    });
                }
            },
        },
        mounted() {
            this.isBrowser = process.browser
        }
    };
</script>

<style scoped>
.errors-container2 {
    height: auto;
    width: 100%;
    background: rgba(215, 83, 83, 0.08);
    margin-top: 15px;
}
.errors-container2 p {
    color: #D75353;
    line-height: 20px;
    font-size: var(--fs-small);
}
.reg-inner .submit {
    width: 100%;
    margin-top: 0;
    height: 40px;
    letter-spacing: 0;
    box-shadow: none;
    margin-left: 0;
    margin-right: 0;
    background: #E2C477;
    border-radius: 4px;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    text-transform: uppercase;
    color: #FFFFFF;
}
.check-terms {
    margin-top: 0;
}
.login-label {
    position: absolute;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: rgba(0, 0, 0, 0.64);
}
.reg-col {
    display: inline-block;
    width: calc((100% - 4px)/2);
    padding: 8px;
    vertical-align: top;
}
.login-success {
    text-align: center;
    background: url('../assets/success_icon.png') no-repeat center 30px;
    padding: 140px 32px 0;
}
.reg-inner {
    width: 650px;
    margin: 0 auto;
    border: 1px solid #000000;
    border-radius: 8px;
    text-align: center;
    padding: 24px;
}
.fb-reg {
    text-align: center;
    padding: 10px;
    height: 44px;
    background: #FFFFFF url('../assets/landing/fb.png') no-repeat 10px 11px !important;
    border: 1px solid #000000 !important;
    color: #000000 !important;
    box-sizing: border-box;
    border-radius: 4px;
    width: 330px;
    display: block;
    margin: 0 auto;
}
.fb-reg:hover {
    cursor: pointer;
    color: #1f4e79;
    background-color: #ffffff;
}
.social-or {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    display: block;
    text-align: center;
    color: rgba(0, 0, 0, 0.64);
    margin: 25px auto 0;
}
.reg-wraper {
    padding: 64px;
    background: #F6F6F6;
}
.home-section7 {
    min-height: 453px;
    padding: 80px 0;
}
.journey-item {
    display: inline-block;
    width: calc((100% - 294px) / 4);
    text-align: center;
    vertical-align: top;
    margin-bottom: 40px;
}
.journey-num-border {
    width: 56px;
    height: 56px;
    border: 4px solid rgba(0, 0, 0, 0.12);
    border-radius: 50%;
    text-align: center;
    margin: 0 auto 8px;
}
.journey-item1 .journey-num {
    background: #E5CB87;
    border-radius: 50%;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    color: #FFFFFF;
}
.journey-item2 .journey-num {
    background: #C7AC69;
    border-radius: 50%;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    color: #FFFFFF;
}
.journey-item3 .journey-num {
    background: #907D4C;
    border-radius: 50%;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    color: #FFFFFF;
}
.journey-item4 .journey-num {
    background: #5A4E30;
    border-radius: 50%;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    color: #FFFFFF;
}
.journey-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #002840;
}
.journey-separator {
    display: inline-block;
    width: 90px;
    height: 6px;
    vertical-align: top;
    margin-top: 26px;
}
.journey-separator1 {
    background: url("../assets/home/arrow1.png") no-repeat center;
}
.journey-separator2 {
    background: url("../assets/home/arrow2.png") no-repeat center;
}
.journey-separator3 {
    background: url("../assets/home/arrow3.png") no-repeat center;
}
.section-subtitle {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #002840;
    margin-bottom: 40px;
}
.safe-hands-col1,
.safe-hands-col2 {
    vertical-align: top;
    padding-top: 88px;
}

.safe-hands-col1 {
    background: url("../assets/how/safehands1.png") no-repeat center 17px;
}

.safe-hands-col2 {
    background: url("../assets/how/safehands2.png") no-repeat center 17px;
}
h3 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #002840;
    margin-bottom: 8px;
}

h3 a {
    color: inherit;
    text-decoration: none;
}

.we-take-care-col {
    vertical-align: top;
    padding-top: 88px;
    display: inline-block;
    width: calc((100% - 56px) / 3);
    background: url("../assets/how/takecare1.png") no-repeat center 17px;
}

.we-take-care-col2,
.we-take-care-col3 {
    margin-left: 24px;
}

.we-take-care-col2 {
    background: url("../assets/how/takecare2.png") no-repeat center 17px;
}

.we-take-care-col3 {
    background: url("../assets/how/takecare3.png") no-repeat center 17px;
}

.we-take-care-title {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #002840;
    margin-bottom: 8px;
}

.we-take-care-text {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #002840;
}

.section-safe-hands {
    background: #f7f7f7;
}


.home-section6 {
    min-height: 629px;
    padding: 80px 0;
}
.home-section6-item-wrapper {
    vertical-align: top;
}
.home-section6-item {
    display: inline-block;
    width: calc((100% - 56px) / 3);
    padding-left: 53px;
    position: relative;
    vertical-align: top;
    margin-bottom: 42px;
}
.home-section6-item-wrapper > .home-section6-item:nth-child(1),
.home-section6-item-wrapper > .home-section6-item:nth-child(2) {
    margin-right: 24px;
}
.home-section6-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #002840;
    margin-bottom: 8px;
}
.home-section6-subtitle {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #002840;
}
.home-section6-img {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 0;
    left: 0;
}
.guide-content {
    height: 100%;
    padding: 24px;
    background: url("../assets/landing/lp-guide.svg") no-repeat right bottom;
    background-size: 438px 480px;
}
.guide-content.login-inner-container {
    background: #f4f4f4 url("../assets/landing/lp-guide.svg") no-repeat right bottom;
    background-size: 438px 480px;
}
.guide-reg-wrapper, .login-success-btn-wrapper {
    width: calc(100% - 455px);
}
.guide-subtitle {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    align-items: center;
    color: #002840;
    margin-bottom: 21px;
}
.mobile-back {
    display: none;
}
.invest-brand-message, .home-section6 {
    background: #F7F7F7;
}
.theme--light.v-btn.v-btn--has-bg.login-submit {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    gap: 8px;
    width: 100%;
    height: 40px;
    background: #004F7F;
    border-radius: 8px;
    margin-top: 18px;
    text-transform: none;
}
.errors-container2 {
    height: auto;
    width: 100%;
    background: transparent;
    margin: 0;
}

.errors-container2 p {
    color: #D75353;
    line-height: 12px;
    font-size: var(--fs-small);
    padding-left: 0;
    margin-bottom: 0;
    padding-top: 5;
}
.login-success {
    background: url("../assets/how/ok.gif") no-repeat center top;
    background-size: 250px;
    padding-top: 280px;
}
.login-inner-container {
    height: 100%;
    padding: 24px;
}
.login-success-btn-wrapper {
    text-align: center;
}
.additional-info {
    text-align: center;
    margin: 32px auto;
}
.theme--light.v-btn.v-btn--has-bg.btn-bid-proceed {
    background: #004F7F;
    border-color: #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    margin-right: 16px;
}
.theme--light.v-btn.v-btn--has-bg.btn-bid-cancel {
    border: 1px solid #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #004F7F;
}
.marginBottom16 {
    margin-bottom: 16px;
}
.small-subtitle-text {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    margin: 16px auto 0;
    color: #FFFFFF;
}
.home-section1-btn1 {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    display: inline-block;
    color: #004F7F;
}
.home-section2 {
    height: 430px;
    padding: 52px 0 45px;
}
.home-section2-img, .home-section3-img {
    height: 100%;
    width: 100%;
}
.home-section2-img img,
.home-section3-img img {
    background-size: contain;
    height: 100%;
    width: 100%;
}
.home-section2-title {
    color: #002840;
    font-family: Montserrat,Arial,Helvetica,sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 8px;
    margin-top: 39px;
    text-align: left;
}
.home-section2-subtitle {
    align-items: center;
    display: flex;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 24px;
}
.home-section2-bullet,
.home-section2-subtitle {
    color: #002840;
    font-family: Montserrat,Arial,Helvetica,sans-serif;
    font-style: normal;
}
.home-section2-bullet {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #002840;
    padding-left: 17px;
    background: url("../assets/home/bullet-point.svg") no-repeat left center;
}
.home-section2-bullets {
    margin-bottom: 24px;
}
.home-section2-btn1 {
    padding: 8px 16px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    color: #ffffff;
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
}
.home-section2-btn2 {
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #004F7F;
    border: 2px solid #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    height: 36px;
    margin-left: 12px;
}
.home-section2-btn1.btn-white {
    background: #ffffff;
    color: #004F7F;
}
.home-section2-btn1.btn-white:hover {
    cursor: pointer;
}
.home-section2-btn2.border-white {
    border-color: white;
    color: white;
}
.home-section3 {
    padding-bottom: 80px;
}
    .how-enprimeur-item {
        display: inline-block;
        width: calc((100% - 84px) / 4);
        vertical-align: top;
        padding-top: 72px;
        text-align: center;
    }
    .how-enprimeur-item1 {
        background: url("../assets/landing/en1.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item2 {
        background: url("../assets/landing/en2.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item3 {
        background: url("../assets/landing/en3.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item4 {
        background: url("../assets/landing/en4.png") no-repeat center top;
    }
    .how-enprimeur-item-title {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        color: #002840;
    }
    .how-enprimeur-item-text {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: #002840;
        margin-top: 8px;
    }
    .how-enprimeur-wrapper {
        padding-bottom: 60px;
        background: url("../assets/landing/timeline.png") no-repeat center bottom;
    }
    #how-enprimeur {
        background: #F7F7F7;
    }
    .iframe-container2 iframe {
        border: 0;
        width: 100%;
        height: 83px;
        margin-top: 16px;
    }
    .lp-register {
        background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
        color: white;
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
    }


    .home ul {
        padding-left: 0;
    }

    .container {
        position: relative;
        max-width: 1170px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .container1366 {
        position: relative;
        max-width: 1366px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .padding200 {
        padding: 0 200px;
    }
    .padding80 {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .title-border {
        width: 64px;
        height: 4px;
        background: #ECD9A7;
        margin: 24px auto 40px;
    }

    .hidden {
        display: none;
    }

    /* reset */

    table {
        border-spacing: 0;
        border-collapse: collapse;
    }

    fieldset, img, abbr {
        border: 0;
    }

    address, caption, cite, code, dfn, em, strong, th, var {
        font-weight: normal;
        font-style: normal;
    }

    ul li {
        list-style: none;
    }

    caption, th {
        text-align: left;
    }

    button {
        border: none;
        background: none;
    }

    button:hover {
        cursor: pointer;
    }

    a {
        text-decoration: none;
    }

    /* slogan section */
    .carousel-wrapper-new {
        height: 398px;
        position: relative;
        top: 79px;
        margin-bottom: 80px;
    }
    .section-how-to-buy {
        padding-top: 80px;
        padding-bottom: 80px;
        background: #f7f7f7;
    }
    .how-buy-live-market-wrapper {
        height: 242px;
        margin-top: 40px;
        margin-bottom: 40px;
    }
    .how-buy-live-market-wrapper-de {
        height: 285px;
        margin-top: 40px;
        margin-bottom: 40px;
    }
    h2 {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #002840;
        text-align: center;
    }
    .section-how-to-buy-img2 {
        background: url("../assets/home/home_live_market.png") no-repeat center;
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    .section-how-to-buy-img {
        background: url("../assets/home/home_collections_en.png") no-repeat center;
        background-size: contain;
        width: 100%;
        height: 100%;
    }
    .how-buy-enprimeur-wrapper {
        height: 241px;
        margin-top: 40px;
    }
    .section-how-to-buy-img3 {
        background: url("../assets/home/home_en_primeur.png") no-repeat center;
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    html[lang="de"] .section-how-to-buy-img3 {
        background: url('../assets/home/home_en_primeur_de.png') no-repeat center;
        background-size: contain;
    }
    html[lang="it"] .section-how-to-buy-img3 {
        background: url('../assets/home/home_en_primeur_it.png') no-repeat center;
        background-size: contain;
    }
    html[lang="fr"] .section-how-to-buy-img3 {
        background: url('../assets/home/home_en_primeur_fr.png') no-repeat center;
        background-size: contain;
    }
    .home-left-50,
    .home-right-50 {
        display: inline-block;
        width: calc((100% - 24px) / 2);
        height: 100%;
        vertical-align: top;
    }

    .home-left-50 {
        margin-right: 20px;
    }
    .blue-btn {
        padding: 8px 16px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        color: #ffffff;
        display: inline-block;
        vertical-align: top;
        font-family: "Montserrat", Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        text-decoration: none;
        margin-top: 24px;
    }
    .blue-btn:hover {
        cursor: pointer;
    }
    .content-text {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #002840;
        padding-top: 8px;
    }
    .main-img {
        width: 100%;
        height: 100%;
        background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
        background-size: cover;
    }
    .main-img-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
.section1-left,
.section1-right {
    display: inline-block;
    vertical-align: top;
    height: 100%;
}
.section1-right {
    width: 178px;
}
.section1-left {
    margin-right: 24px;
    width: calc(100% - 208px);
}
.section1-title {
    margin-top: 59px;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 44px;
    color: #FFFFFF;
    margin-bottom: 16px;
    text-align: left;
}
.section1-subtitle {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 27px;
    color: #FFFFFF;
    margin-bottom: 32px;
    text-align: left;
}
.home-section1-img {
    width: 100%;
    height: 100%;
    position: relative;
    text-align: right;
    background-size: contain;
    background-position: right center;
}
.home-section1-img img {
    background-size: contain;
    width: 100%;
    height: 100%;
    max-height: 360px;
    max-width: 180px;
}
    .section1-container {
        height: 100%;
        padding: 32px 200px;
    }
    .main-title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 120px auto 0;
        text-align: center;
        max-width: 966px;
    }
    .main-title h1 {
        color: #ffffff;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 36px;
        line-height: 44px;
        margin-bottom: 0;
    }
    .main-subtitle {
        margin-top: 16px;
        margin-bottom: 32px;
        text-align: center;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 27px;
        color: #ffffff;
    }
    .iframe-container {
        width: 100%;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
    .iframe-container iframe {
        border: 0;
        width: 100%;
        height: 132px;
        border-radius: 32px;
    }

    /* START Top Collections */
    .home-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #002840;
        margin-bottom: 24px;
        position: relative;
        text-align: center;
    }

    .show-all-btn {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 120px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        display: block;
        color: #FFFFFF;
        text-align: center;
        margin: 0 auto;
    }

    .home-collections-container {
        max-width: 1214px;
        margin: 0 auto;
    }

    /* END Top Collections */

    .home-title-wine {
        text-align: center;
        font-weight: 400;
        font-size: 40px;
        line-height: 47px;
        margin: 24px auto 40px;
    }
    .home-title-live {
        margin-top: 50px;
    }

    .browse-market-btn {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 321px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #FFFFFF;
        display: block;
        text-align: center;
        margin: 46px auto 0;
    }
    .browse-market-btn-de {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 321px;
        height: 56px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #FFFFFF;
        display: block;
        text-align: center;
        margin: 46px auto 0;
    }
    #latest-offers {
        background-color: #F7F7F7;
    }
    .latest-offers-wrapper {
        margin-top: 16px;
    }
    .how-buy-collection-wrapper {
        height: 227px;
    }
    .how-buy-collection-wrapper h3 {
        padding-top: 40px;
    }

    .invest-brand-message h3, .invest-brand-message h3 a {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: #002840;
    }

.invest-brand-message .content-text {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #002840;
    padding-top: 8px;
}
.how-buy-live-market-wrapper h3 {
    padding-top: 16px;
}
.center {
    text-align: center;
}

    @media(max-width: 767px) {
        .reg-inner {
            width: 100%;
        }
        .reg-wraper {
            padding: 64px 15px;
        }
        .fb-reg {
            width: 100%;
        }
        .reg-col {
            width: 100%;
        }
        .home-section7 {
            min-height: auto;
            padding: 32px 0;
        }
        .journey-item {
            display: block;
            width: 100%;
            margin-bottom: 40px;
        }
        .journey-separator {
            display: block;
            width: 90px;
            height: 106px;
            vertical-align: top;
            margin: 0 auto;
            transform: rotate(90deg);
        }
        .journey-item.journey-item2,
        .journey-item.journey-item3,
        .journey-item.journey-item4 {
            margin-top: 40px;
        }
        .carousel-wrapper-new {
            height: 400px;
        }
        .section1-container {
            padding: 16px;
        }
        .section1-title {
            margin-top: 20px;
            font-size: 17px;
            line-height: 24px;
            margin-bottom: 10px;
        }
        .section1-subtitle {
            font-size: 14px;
            line-height: 17px;
        }
        .home-section1-btn1,
        .home-section1-btn2 {
            display: block;
            text-align: center;
        }
        .home-section1-btn1 {
            margin-bottom: 12px;
        }
        .home-section1-btn2 {
            margin-left: 0;
        }
        .home-section2, .home-section3 {
            height: auto;
            padding: 16px 0;
        }
        .home-section2 .container1366, .home-section3 .container1366 {
            height: 100%;
        }
        .home-left-50 {
            height: 200px;
            margin-right: 0;
        }
        .how-safe-hands-wrapper .home-left-50 {
            height: auto;
        }
        .home-left-50, .home-right-50 {
            display: block;
            width: 100%;
        }
        .home-section3 .home-left-50 {
            height: auto;
        }
        .how-buy-live-market-wrapper,
        .how-buy-live-market-wrapper-de,
        .how-buy-collection-wrapper,
        .how-buy-enprimeur-wrapper {
            height: auto;
        }
        .guide-content {
            background: #ffffff;
        }
        .we-take-care-col {
            display: block;
            width: 100%;
        }
        .we-take-care-col2, .we-take-care-col3 {
            margin-left: 0;
        }
        .guide-reg-wrapper,
        .theme--light.v-btn.v-btn--has-bg.login-submit {
            width: 100%;
        }
        .mobile-back {
            display: block;
            height: 177px;
            margin-top: 32px;
            margin-bottom: 32px;
            width: 100%;
            background: url("../assets/how/mobile_back.png") no-repeat right bottom;
        }
        .guide-title {
            width: calc(100% - 30px);
        }
        .home-section6 {
            padding: 32px 0 0;
        }
        .home-section6-item {
            display: block;
            width: 100%;
            padding-left: 53px;
            margin-bottom: 42px;
        }
        .home-section6-item-wrapper > .home-section6-item:nth-child(1),
        .home-section6-item-wrapper > .home-section6-item:nth-child(2) {
            margin-right: 0;
        }
        .home-left-50, .home-right-50 {
            display: block;
            width: 100%;
        }
        .section-how-to-buy-img2 {
            height: 200px;
        }
        .main-title {
            font-size: 22px;
            line-height: 36px;
            margin: 70px auto;
        }
        .home-title {
            font-size: 17px;
            line-height: 17px;
            font-weight: 700;
        }
        .collections-h1 {
            font-size: 22px;
        }
        .show-all-btn {
            display: none;
        }
        .browse-market-btn, .browse-market-btn-de {
            margin-bottom: 32px;
        }
        .iframe-container2 {
            width: 320px;
            margin: 16px auto 0;
        }
        .iframe-container2 iframe {
            height: 132px;
        }
        .how-enprimeur-item {
            display: block;
            width: 100%;
        }
        .how-enprimeur-item1, .how-enprimeur-item2, .how-enprimeur-item3 {
            margin-bottom: 32px;
        }
        .how-enprimeur-wrapper {
            background: transparent;
        }
        .how-icon {
            margin-top: 32px;
        }
        .padding200 {
            padding: 0 16px;
        }
        .padding80 {
            padding-top: 32px;
            padding-bottom: 32px;
        }
    }
</style>

<style>
.page-lp-collections .flex {
    margin-top: 20px;
    text-align: left;
    position: relative;
}
.page-lp-collections .v-text-field__details {
    bottom: -7px;
    position: absolute;
}
.page-lp-collections .v-input input {
    height: 40px;
    max-height: unset;
    margin-top: 4px;
    padding-left: 15px;
}
.page-lp-collections .v-text-field .v-input__append-inner {
    margin-top: 4px;
    background: #fff;
    height: 40px;
}
.page-lp-collections .v-text-field .v-input__append-inner .v-input__icon {
    margin-top: 8px;
    margin-right: 3px;
}
.page-lp-collections .v-text-field .v-input__append-inner .primary--text {
    color: #000 !important;
    caret-color: #000 !important;
}
.page-lp-collections .theme--light.v-input:not(.v-input--is-disabled) input {
    border: 0;
}
.page-lp-collections .theme--light.v-text-field:not(.v-input--has-state)>.v-input__control>.v-input__slot:hover:before {
    border-color: var(--brand);
}
.page-lp-collections .theme--light.v-text-field>.v-input__control>.v-input__slot:after {
    border-color: rgba(0,0,0,.87);
    border-width: 1px;
}
.page-lp-collections .theme--light.v-text-field.error--text>.v-input__control>.v-input__slot:after {
    border-color: #ff5252;
}
.page-lp-collections .v-input--checkbox .v-messages {
    display: none;
}

.page-lp-collections .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin-bottom: 6px;
}
.page-lp-collections .v-input input[type=checkbox] {
    width: 18px;
    height: 18px;
}

.page-lp-collections .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot .v-icon.v-icon {
    font-size: 18px;
}

.page-lp-collections .v-input--selection-controls__input {
    margin-right: 0;
}

.page-lp-collections .v-input--selection-controls.v-input .v-label {
    font-size: 12px;
}

.page-lp-collections .v-application .accent--text {
    color: #E2C477 !important;
    caret-color: #E2C477 !important;
}
.fb-reg .logo,
.fb-reg .v-loader.loader {
    display: none;
}
.fb-reg button {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 14px;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.88);
}
.page-lp-collections .not-logged-btn-wrapper {
    display: none;
}
.page-lp-collections .site-navigation-not-logged {
    position: absolute;
    right: 32px;
    top: 24px;
}
.page-lp-collections .site-navigation-not-logged li {
    display: none;
}
.page-lp-collections .site-navigation-not-logged li.lang-nav {
    display: block;
}
.theme--light.v-btn.v-btn--has-bg.login-submit span {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
}
</style>
